import { Controller } from "@hotwired/stimulus";

// Generic tab switcher: clicking a tab shows the matching panel (matched by
// index) and hides the rest. Used on the mata-mata page to switch between
// Série Ouro / Prata / Bronze without a full page reload, which matters on
// mobile where re-navigating is slower and loses scroll position.
export default class extends Controller {
  static targets = ["tab", "panel"];

  connect() {
    if (
      this.tabTargets.length &&
      !this.tabTargets.some((tab) => tab.classList.contains("is-active"))
    ) {
      this.select({ currentTarget: this.tabTargets[0] });
    }
  }

  select(event) {
    const index = this.tabTargets.indexOf(event.currentTarget);
    if (index === -1) return;

    this.tabTargets.forEach((tab, i) => this.setActiveTab(tab, i === index));
    this.panelTargets.forEach((panel, i) =>
      panel.classList.toggle("hidden", i !== index),
    );
  }

  setActiveTab(tab, active) {
    tab.classList.toggle("is-active", active);
    tab.classList.toggle("bg-amber-500", active);
    tab.classList.toggle("text-neutral-950", active);
    tab.classList.toggle("text-neutral-600", !active);
  }
}
